module.exports = __webpack_public_path__ + "static/media/ipams-map.3ae9608f.jpg";